var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "insert-rec",
        "insert-shop-card",
        _vm.expiredClass,
        _vm.cursorClass,
      ],
    },
    [
      _c(
        "a",
        {
          staticClass: "insert-box sendAction padding-zero",
          attrs: {
            href: _vm.linkUrl,
            "data-spm-data": "v",
            "data-spm-content": _vm.dataSpmContent,
            target: "_blank",
            "data-acode": "8888",
          },
        },
        [
          _c(
            "div",
            { staticClass: "external-video" },
            [
              _vm.type == 37
                ? [
                    _c(
                      "div",
                      { staticClass: "video-detail border-bottom-zero" },
                      [
                        _vm.title
                          ? _c("h5", { staticClass: "title" }, [
                              _vm._v(_vm._s(_vm.title)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.desc
                          ? _c("div", { staticClass: "content" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.desc) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.btnText
                          ? _c(
                              "div",
                              { staticClass: "insert-btn-fix fix-position" },
                              [_vm._v(_vm._s(_vm.btnText))]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sohu-video-container",
                        on: { click: _vm.playVideo },
                      },
                      [
                        _c("img", {
                          staticClass: "bg-video play-video",
                          attrs: {
                            src: _vm.image,
                            "data-videoUrl": _vm.videoUrl,
                          },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "play-logo play-video",
                          attrs: { "data-videoUrl": _vm.videoUrl },
                        }),
                      ]
                    ),
                  ]
                : _vm.type == 38
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "sohu-video-container",
                        on: { click: _vm.playVideo },
                      },
                      [
                        _c("img", {
                          staticClass: "bg-video play-video",
                          attrs: {
                            src: _vm.image,
                            "data-videoUrl": _vm.videoUrl,
                          },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "play-logo play-video",
                          attrs: { "data-videoUrl": _vm.videoUrl },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "video-detail border-top-zero" }, [
                      _vm.title
                        ? _c("h5", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.title)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.desc
                        ? _c("div", { staticClass: "content" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.desc) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.btnText
                        ? _c(
                            "div",
                            { staticClass: "insert-btn-fix fix-position" },
                            [_vm._v(_vm._s(_vm.btnText))]
                          )
                        : _vm._e(),
                    ]),
                  ]
                : _c(
                    "div",
                    {
                      staticClass: "sohu-video-container",
                      on: { click: _vm.playVideo },
                    },
                    [
                      _c("img", {
                        staticClass: "bg-video play-video",
                        attrs: {
                          src: _vm.image,
                          "data-videoUrl": _vm.videoUrl,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "play-logo play-video",
                        attrs: { "data-videoUrl": _vm.videoUrl },
                      }),
                    ]
                  ),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.cardInfo.accountName && _vm.cardInfo.avatar
        ? _c("div", { staticClass: "rec rec-widthFix" }, [
            _c("div", { staticClass: "rec-avator" }, [
              _c("img", { attrs: { src: _vm.cardInfo.avatar } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "rec-text" }, [
              _vm._v(_vm._s(_vm.cardInfo.accountName) + "推荐"),
            ]),
            _vm._v(" "),
            _vm.status === 4 || _vm.status === 3
              ? _c("div", { staticClass: "rec-expired-tag" }, [
                  _vm._v("已失效"),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }